'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('../styles/styled.js');
var css = require('../../../system/esm/css.js');
var compose = require('../../../system/esm/compose.js');
var borders = require('../../../system/esm/borders.js');
var display = require('../../../system/esm/display.js');
var flexbox = require('../../../system/esm/flexbox.js');
var grid = require('../../../system/esm/grid.js');
var positions = require('../../../system/esm/positions.js');
var palette = require('../../../system/esm/palette.js');
var shadows = require('../../../system/esm/shadows.js');
var sizing = require('../../../system/esm/sizing.js');
var spacing = require('../../../system/esm/spacing.js');
var typography = require('../../../system/esm/typography.js');

var styleFunction = css(compose(borders["default"], display["default"], flexbox["default"], grid["default"], positions["default"], palette["default"], shadows, sizing["default"], spacing["default"], typography["default"]));
/**
 * @ignore - do not document.
 */

var Box = styled('div')(styleFunction, {
  name: 'MuiBox'
});
var Box$1 = Box;

exports["default"] = Box$1;
exports.styleFunction = styleFunction;
